import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0efa44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增类别 ")
const _hoisted_4 = { class: "d-flex justify-content--center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = { class: "d-flex justify-content--center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = { class: "d-flex justify-content--center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex mt-20" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_13 = { class: "d-flex mt-10" }
const _hoisted_14 = { class: "d-flex justify-content--center align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-5" }, "价格上限", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("¥")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_18 = { class: "d-flex mt-10" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "d-flex mt-20" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_24 = { class: "d-flex mt-10" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "d-flex mt-20" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))
const _hoisted_29 = { class: "dialog-footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("确 定 ")

import Api from '@/http/modules/index'
import {getCurrentInstance, onBeforeMount, reactive, ref} from "vue";
import {
  depreciationMethods,
  type_consumables,
  type_fixed,
  type_intangible,
  types
} from './ViewsComponents/officeAssets/OfficeAssetUtils'
import {ElMessage} from "element-plus";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'GET/office/asset/categories': categoryListApi,
  'POST/office/asset/category': addOrUpdateCategoryApi,
  'POST/office/asset/category/{id}/disable': disableCategoryApi,
  'POST/office/asset/category/{id}/enable': enableCategoryApi,
} = Api
let instance: any = getCurrentInstance()
const globalProperties = instance.appContext.config.globalProperties
const createOrUpdateForm = ref()


const allCategories = reactive<{ isLoading: Boolean, CONSUMABLES: any[], FIXED: any[], INTANGIBLE: any[] }>({
  isLoading: false,
  CONSUMABLES: [],
  FIXED: [],
  INTANGIBLE: []
})
onBeforeMount(() => {
  getCategories()
})

const createOrUpdateDialogInfo = reactive<{
  isShow: Boolean,
  isEdit: Boolean,
  id: number | null, type: string, no: string, name: string,
  maxPrice: number | null, period: number | null, depreciationMethod: string | null, category: any,
  loading: Boolean
}>({
  isShow: false,
  isEdit: false,
  name: '',
  id: null,
  no: '',
  type: "",
  maxPrice: null,
  period: null,
  depreciationMethod: null,
  category: null,
  loading: false
})

const handleCommand = (type: string) => {
  createOrUpdateDialogInfo.category = null
  createOrUpdateDialogInfo.isEdit = false
  createOrUpdateDialogInfo.id = null
  createOrUpdateDialogInfo.type = type
  createOrUpdateDialogInfo.no = ''
  createOrUpdateDialogInfo.name = ''
  createOrUpdateDialogInfo.maxPrice = null
  createOrUpdateDialogInfo.period = null
  createOrUpdateDialogInfo.depreciationMethod = null
  createOrUpdateDialogInfo.isShow = true
  setTimeout(() => {
    createOrUpdateForm.value.resetFields()
  }, 50)
}
const createOrUpdate = () => {
  createOrUpdateForm.value.validate((valid: boolean) => {
    if (valid) {
      createOrUpdateDialogInfo.loading = true
      addOrUpdateCategoryApi({
        id: createOrUpdateDialogInfo.id,
        type: createOrUpdateDialogInfo.type,
        no: createOrUpdateDialogInfo.no,
        name: createOrUpdateDialogInfo.name,
        maxPrice: createOrUpdateDialogInfo.maxPrice ? createOrUpdateDialogInfo.maxPrice : 0,
        period: createOrUpdateDialogInfo.period ? createOrUpdateDialogInfo.period : 0,
        depreciationMethod: createOrUpdateDialogInfo.depreciationMethod
      }).then((r: any) => {
        if (createOrUpdateDialogInfo.isEdit) {
          //编辑
          createOrUpdateDialogInfo.category.name = createOrUpdateDialogInfo.name
          createOrUpdateDialogInfo.category.maxPrice = createOrUpdateDialogInfo.maxPrice
          createOrUpdateDialogInfo.category.period = createOrUpdateDialogInfo.period
          createOrUpdateDialogInfo.category.depreciationMethod = createOrUpdateDialogInfo.depreciationMethod
          createOrUpdateDialogInfo.category.depreciationMethodDesc = r.depreciationMethodDesc
        } else {
          if (r.type.toUpperCase() === type_fixed) {
            allCategories.FIXED.push(r);
          } else if (r.type.toUpperCase() === type_intangible) {
            allCategories.INTANGIBLE.push(r);
          } else {
            allCategories.CONSUMABLES.push(r);
          }
        }
        ElMessage.success(createOrUpdateDialogInfo.id ? '修改类别成功' : '添加类别成功')
        createOrUpdateDialogInfo.loading = false
        createOrUpdateDialogInfo.isShow = false
      }).catch((e: any) => {
        createOrUpdateDialogInfo.loading = false
        // globalProperties.$message.error((createOrUpdateDialogInfo.id ? '修改类别失败' : '添加类别失败') + e)
      })
    } else {
      return false
    }
  })
}

const getCategories = () => {
  categoryListApi().then((r: any) => {
    allCategories.CONSUMABLES = r.CONSUMABLES
    allCategories.FIXED = r.FIXED
    allCategories.INTANGIBLE = r.INTANGIBLE
  })
}
const activeTable = ref(type_fixed)
const onClickTab = (tab: any, event: any) => {
}

const editCategory = (category: any) => {
  createOrUpdateDialogInfo.category = category
  createOrUpdateDialogInfo.isEdit = true
  createOrUpdateDialogInfo.id = category.id
  createOrUpdateDialogInfo.type = category.type
  createOrUpdateDialogInfo.no = category.no
  createOrUpdateDialogInfo.name = category.name
  createOrUpdateDialogInfo.maxPrice = category.maxPrice
  createOrUpdateDialogInfo.period = category.period
  createOrUpdateDialogInfo.depreciationMethod = category.depreciationMethod
  createOrUpdateDialogInfo.isShow = true
}
const opCategory = (category: any) => {
  if (category.valid) {
    globalProperties.$confirm("您确认要禁用类别（" + category.no + "）吗？", "提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      disableCategoryApi({id: category.id}).then((r: any) => {
        category.valid = false
        globalProperties.$message.success("禁用类别成功");
      }).catch((e: any) => {
        globalProperties.$message.error("禁用类别失败：" + e)
      })
    }).catch(() => {
      //ignore
    })
  } else {
    globalProperties.$confirm("您确认要重新启用类别（" + category.no + "）吗？", "提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      enableCategoryApi({id: category.id}).then((r: any) => {
        category.valid = true
        globalProperties.$message.success("重新启用类别成功");
      }).catch((e: any) => {
        globalProperties.$message.error("重新启用类别失败：" + e)
      })
    }).catch(() => {
      //ignore
    })

  }

}
const headerClass = (row: any, rowIndex: any) => {
  // console.log("headerClass", rowIndex, row)
  return "header-title"
}


return (_ctx: any,_cache: any) => {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        type: "primary",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (item) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  key: item.value,
                  command: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["command"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_icon, { class: "ml-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowDown)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_tabs, {
      class: "tabs",
      modelValue: activeTable.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTable).value = $event)),
      "tab-position": "left",
      style: {"height":"800px"},
      onTabClick: onClickTab
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "固定资产",
          name: _unref(type_fixed),
          class: "pr-10"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "fixedCategories",
              border: "",
              class: "mt-10",
              data: _unref(allCategories).FIXED,
              "row-key": "id",
              "header-row-class-name": headerClass,
              "max-height": 800
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别编号",
                  prop: "no",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别名称",
                  prop: "name",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "价格上限",
                  prop: "maxPrice",
                  align: "right",
                  width: "132"
                }),
                _createVNode(_component_el_table_column, {
                  label: "企业折旧年限",
                  prop: "period",
                  width: "132"
                }),
                _createVNode(_component_el_table_column, {
                  label: "折旧方式",
                  prop: "depreciationMethodDesc"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "valid",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_button, {
                      type: row.valid?'success':'info',
                      size: "small",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.valid ? '有效' : '禁用'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "200"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            disabled: !row.valid,
                            onClick: ($event: any) => (editCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]),
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (opCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.valid ? "禁用" : "重新启用"), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _unref(allCategories).isLoading]
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "无形资产",
          name: _unref(type_intangible),
          lazy: "",
          class: "pr-10"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "INTANGIBLECategories",
              border: "",
              class: "mt-10",
              data: _unref(allCategories).INTANGIBLE,
              "row-key": "id",
              "header-row-class-name": headerClass,
              "max-height": 800
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别编号",
                  prop: "no",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别名称",
                  prop: "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "企业折旧年限",
                  prop: "period"
                }),
                _createVNode(_component_el_table_column, {
                  label: "折旧方式",
                  prop: "depreciationMethodDesc"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "valid",
                  width: "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_button, {
                      type: row.valid?'success':'info',
                      size: "small",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.valid ? '有效' : '禁用'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "200"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            disabled: !row.valid,
                            onClick: ($event: any) => (editCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]),
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (opCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.valid ? "禁用" : "重新启用"), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _unref(allCategories).isLoading]
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "耗材",
          name: _unref(type_consumables),
          lazy: "",
          class: "pr-10"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "CONSUMABLESCategories",
              border: "",
              class: "mt-10",
              data: _unref(allCategories).CONSUMABLES,
              "row-key": "id",
              "header-row-class-name": headerClass,
              "max-height": 800
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  type: "index",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别编号",
                  prop: "no"
                }),
                _createVNode(_component_el_table_column, {
                  label: "类别名称",
                  prop: "name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "状态",
                  prop: "valid"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_button, {
                      type: row.valid?'success':'info',
                      size: "small",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.valid ? '有效' : '禁用'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right",
                  width: "200"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            disabled: !row.valid,
                            onClick: ($event: any) => (editCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]),
                          _createVNode(_component_el_link, {
                            type: "danger",
                            onClick: ($event: any) => (opCategory(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.valid ? "禁用" : "重新启用"), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, _unref(allCategories).isLoading]
            ])
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "createOrUpdateDialog",
      modelValue: _unref(createOrUpdateDialogInfo).isShow,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(createOrUpdateDialogInfo).isShow) = $event)),
      draggable: "",
      width: "860px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(createOrUpdateDialogInfo).isEdit ? '编辑' : '新增'), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(createOrUpdateDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_30
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: createOrUpdate,
            loading: _unref(createOrUpdateDialogInfo).loading,
            disabled: _unref(createOrUpdateDialogInfo).loading
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "createOrUpdateForm",
          ref_key: "createOrUpdateForm",
          ref: createOrUpdateForm,
          model: _unref(createOrUpdateDialogInfo)
        }, {
          default: _withCtx(() => [
            (_unref(createOrUpdateDialogInfo).type==='FIXED')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_el_form_item, {
                      label: "类别编号",
                      prop: "no",
                      class: "flex-1",
                      required: "",
                      rules: [{required:true,message:'请填写类别编号'},{max:6,message:'最多6位'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(createOrUpdateDialogInfo).no,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(createOrUpdateDialogInfo).no) = $event)),
                          disabled: _unref(createOrUpdateDialogInfo).isEdit,
                          placeholder: "请输入最多6个大写字母的编号",
                          oninput: "value=value.replace(/[^A-Z]/g,'')"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _hoisted_12,
                    _createVNode(_component_el_form_item, {
                      label: "类别名称",
                      prop: "name",
                      class: "flex-1",
                      required: "",
                      rules: [{required:true,message:'请填写类别名称'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(createOrUpdateDialogInfo).name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(createOrUpdateDialogInfo).name) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_form_item, {
                      prop: "maxPrice",
                      class: "flex-1",
                      required: "",
                      rules: [{required:true,message:'请填写价格上限'}]
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: "超出价格上限的物品可以理解为贵重物品，盘点时高亮显示，并且领用人需要拍照上传资产照片并确认。",
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WarningFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(createOrUpdateDialogInfo).maxPrice,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(createOrUpdateDialogInfo).maxPrice) = $event)),
                          oninput: "value=value.replace(/[^\\d]/g,'')"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_el_button, { plain: "" }, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_17,
                    _createVNode(_component_el_form_item, {
                      label: "企业折旧年限",
                      prop: "period",
                      class: "flex-1",
                      required: "",
                      rules: [{required:true,message:'请填写企业折旧年限'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(createOrUpdateDialogInfo).period,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(createOrUpdateDialogInfo).period) = $event)),
                          oninput: "value=value.replace(/[^\\d]/g,'')"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_form_item, {
                      label: "折旧方式",
                      prop: "depreciationMethod",
                      class: "flex-1",
                      required: "",
                      rules: [{required:true,message:'请选择折旧方式'}]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(createOrUpdateDialogInfo).depreciationMethod,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(createOrUpdateDialogInfo).depreciationMethod) = $event)),
                          placeholder: "折旧方式"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depreciationMethods), (method, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: method.value,
                                label: method.label,
                                value: method.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_19,
                    _hoisted_20
                  ])
                ]))
              : (_unref(createOrUpdateDialogInfo).type==='INTANGIBLE')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_el_form_item, {
                        label: "类别编号",
                        prop: "no",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请填写类别编号'},{max:6,message:'最多6位'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(createOrUpdateDialogInfo).no,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(createOrUpdateDialogInfo).no) = $event)),
                            disabled: _unref(createOrUpdateDialogInfo).isEdit,
                            placeholder: "请输入最多6个大写字母的编号",
                            oninput: "value=value.replace(/[^A-Z]/g,'')"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _hoisted_23,
                      _createVNode(_component_el_form_item, {
                        label: "类别名称",
                        prop: "name",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请填写类别名称'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(createOrUpdateDialogInfo).name,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(createOrUpdateDialogInfo).name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_form_item, {
                        label: "企业折旧年限",
                        prop: "period",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请填写企业折旧年限'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(createOrUpdateDialogInfo).period,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(createOrUpdateDialogInfo).period) = $event)),
                            oninput: "value=value.replace(/[^\\d.]/g,'')"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_25,
                      _createVNode(_component_el_form_item, {
                        label: "折旧方式",
                        prop: "depreciationMethod",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请选择折旧方式'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(createOrUpdateDialogInfo).depreciationMethod,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(createOrUpdateDialogInfo).depreciationMethod) = $event)),
                            placeholder: "折旧方式"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depreciationMethods), (method, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: method.value,
                                  label: method.label,
                                  value: method.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_el_form_item, {
                        label: "类别编号",
                        prop: "no",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请填写类别编号'},{max:6,message:'最多6位'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(createOrUpdateDialogInfo).no,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(createOrUpdateDialogInfo).no) = $event)),
                            disabled: _unref(createOrUpdateDialogInfo).isEdit,
                            placeholder: "请输入最多6个大写字母的编号",
                            oninput: "value=value.replace(/[^A-Z]/g,'')"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _hoisted_28,
                      _createVNode(_component_el_form_item, {
                        label: "类别名称",
                        prop: "name",
                        class: "flex-1",
                        required: "",
                        rules: [{required:true,message:'请填写类别名称'}]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(createOrUpdateDialogInfo).name,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(createOrUpdateDialogInfo).name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})